module.exports = __webpack_public_path__ + "media/images/flags/bn-7980b3a959e8b1f865a287fc4ddac53b.svg";